import model from "@/model";
import commonMixin from "@/components/common/mini-table/mixins/common-mixin";

export default {
    mixins: [commonMixin],
    props: {
        needModelFields: {
            type: Boolean,
            default: false
        },
        entityName: String,
        customVuexName: String,

        enableOriginField: {
            type: Boolean,
            default: false
        },

    },
    computed: {
        rowListCover() {
            return this.enableOriginField ? this.items : this.rowList;
        },
        modelFieldsAvailable() {
            return this.needModelFields && this.entityName !== undefined;
        },
        //--------from em table
        modelGridFields() {
            if (this.modelFieldsAvailable) {
                let modelConfigs = this.customVuexName === undefined ?
                    model[this.entityName].gridFields() :
                    model[this.entityName][`${this.customVuexName}VoConfigs`];
                let tempList = [];
                for (let item of modelConfigs) {
                    if (!item.isDetail) {
                        tempList.push(item);
                    }
                }
                return tempList;
            } else if (this.entityName) {
                return this.fieldsBeforeCustomized;
            }
            return [];
        },
        customizedFieldLocalstorageKey() {
            return this.entityTableKey == null ? '' : 'mini-table-custom-fields-' + this.entityTableKey;
        },
        entityTableKey() {
            if (this.modelFieldsAvailable) {
                let cvn = this.customVuexName ? this.customVuexName : 'rows';
                return `${this.entityName}-${cvn}`;
            } else if (this.entityName) {
                return this.entityName;
            }
            return null;
        },
    },
    data() {
        return {
            fieldsBeforeCustomized: [],

            editInvisibleFields: [],
        }
    },
    methods: {
        //获取本地保存的列配置
        initCustomVuexFields() {
            let customized = false;
            let gridFields = [];
            if (this.modelFieldsAvailable) {
                gridFields = this.modelGridFields;
                let storageFieldsConfig = this.lookLocalStorageFieldsConfig(gridFields);
                if (storageFieldsConfig.length > 0) {
                    gridFields = storageFieldsConfig;
                }
                gridFields = this.translateFieldConfig(gridFields);
                customized = true;
            }
            //merge both
            if (this.fields !== undefined) {
                let tempList = [];
                for (let temp of this.fields) {
                    let has = false;
                    for (let gf of gridFields) {
                        if (gf.key === temp.key) {
                            has = true;
                            this.copyObj2Obj(temp, gf, true);
                            break;
                        }
                    }
                    if (temp.isEditInvisible) {
                        this.editInvisibleFields.push(temp);
                    } else if (!has) {
                        tempList.push(temp);
                    }
                }
                this.pushAll(tempList, gridFields);
            }
            this.fieldsBeforeCustomized = gridFields;
            if (!customized) {
                let temp = this.lookLocalStorageFieldsConfig(gridFields);
                if (temp.length > 0) {
                    gridFields = temp;
                }
            }
            this.localFields = gridFields;
        },
        lookLocalStorageFieldsConfig(fieldList) {
            let customFields = [];
            if (localStorage[this.customizedFieldLocalstorageKey]) {
                let localStorageKeyArray = JSON.parse(localStorage[this.customizedFieldLocalstorageKey]);
                localStorageKeyArray.forEach(lsf => {
                    let key = typeof lsf === 'string' ? lsf : lsf.key;
                    let originField = fieldList.find(f => f.key === key);
                    if (originField) {
                        customFields.push(originField);
                    }
                });
            }
            return customFields;
        },
    },
}
